import { forwardRef as p, useCallback as M, createElement as h, cloneElement as d } from "react";
import { MULTI_TO_COMPONENT as g } from "./index.es5446.js";
import { BasicMenuItem as E } from "./index.es77.js";
const l = p(
  ({
    multi: f,
    onItemSelect: o,
    value: r,
    isSelected: C,
    isDisabled: n,
    itemSelectArea: c = "all",
    wrapperStyle: t,
    ...i
  }, m) => {
    const k = M(() => {
      n || o == null || o(r);
    }, [n, o, r]);
    return /* @__PURE__ */ h(
      E,
      {
        ...i,
        ref: m,
        key: r,
        isSelected: C,
        isMulti: f !== "switch",
        isDisabled: n,
        onClick: c === "all" ? k : void 0,
        LeftComponent: d(g[f], {
          checked: C,
          disabled: n,
          onCheckedChange: c === "toggler" ? k : void 0
        }),
        value: r,
        wrapperStyle: t
      }
    );
  }
);
export {
  l as MultiSelectItem
};
//# sourceMappingURL=index.es78.js.map
